function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { array } from 'vega-util';
import * as log from '../log';
import { isLayerSpec, isUnitSpec } from '../spec';
import { keys } from '../util';
import { assembleAxisSignals } from './axis/assemble';
import { parseLayerAxes } from './axis/parse';
import { parseData as _parseData } from './data/parse';
import { assembleLayoutSignals as _assembleLayoutSignals } from './layoutsize/assemble';
import { parseLayerLayoutSize } from './layoutsize/parse';
import { assembleLegends as _assembleLegends } from './legend/assemble';
import { Model } from './model';
import { assembleLayerSelectionMarks } from './selection/assemble';
import { UnitModel } from './unit';
import { isTimerSelection } from './selection';
import { MULTI_VIEW_ANIMATION_UNSUPPORTED } from '../log/message';
export var LayerModel = /*#__PURE__*/function (_Model) {
  function LayerModel(spec, parent, parentGivenName, parentGivenSize, config) {
    var _this;
    _classCallCheck(this, LayerModel);
    _this = _callSuper(this, LayerModel, [spec, 'layer', parent, parentGivenName, config, spec.resolve, spec.view]);
    var layoutSize = _objectSpread(_objectSpread(_objectSpread({}, parentGivenSize), spec.width ? {
      width: spec.width
    } : {}), spec.height ? {
      height: spec.height
    } : {});
    _this.children = spec.layer.map(function (layer, i) {
      if (isLayerSpec(layer)) {
        return new LayerModel(layer, _this, _this.getName("layer_".concat(i)), layoutSize, config);
      } else if (isUnitSpec(layer)) {
        return new UnitModel(layer, _this, _this.getName("layer_".concat(i)), layoutSize, config);
      }
      throw new Error(log.message.invalidSpec(layer));
    });
    return _this;
  }
  _inherits(LayerModel, _Model);
  return _createClass(LayerModel, [{
    key: "parseData",
    value: function parseData() {
      this.component.data = _parseData(this);
      var _iterator = _createForOfIteratorHelper(this.children),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;
          child.parseData();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "parseLayoutSize",
    value: function parseLayoutSize() {
      parseLayerLayoutSize(this);
    }
  }, {
    key: "parseSelections",
    value: function parseSelections() {
      // Merge selections up the hierarchy so that they may be referenced
      // across unit specs. Persist their definitions within each child
      // to assemble signals which remain within output Vega unit groups.
      this.component.selection = {};
      var _iterator2 = _createForOfIteratorHelper(this.children),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var child = _step2.value;
          child.parseSelections();
          var _iterator3 = _createForOfIteratorHelper(keys(child.component.selection)),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var key = _step3.value;
              this.component.selection[key] = child.component.selection[key];
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (Object.values(this.component.selection).some(function (selCmpt) {
        return isTimerSelection(selCmpt);
      })) {
        log.error(MULTI_VIEW_ANIMATION_UNSUPPORTED);
      }
    }
  }, {
    key: "parseMarkGroup",
    value: function parseMarkGroup() {
      var _iterator4 = _createForOfIteratorHelper(this.children),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var child = _step4.value;
          child.parseMarkGroup();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "parseAxesAndHeaders",
    value: function parseAxesAndHeaders() {
      parseLayerAxes(this);
    }
  }, {
    key: "assembleSelectionTopLevelSignals",
    value: function assembleSelectionTopLevelSignals(signals) {
      return this.children.reduce(function (sg, child) {
        return child.assembleSelectionTopLevelSignals(sg);
      }, signals);
    }
    // TODO: Support same named selections across children.
  }, {
    key: "assembleSignals",
    value: function assembleSignals() {
      return this.children.reduce(function (signals, child) {
        return signals.concat(child.assembleSignals());
      }, assembleAxisSignals(this));
    }
  }, {
    key: "assembleLayoutSignals",
    value: function assembleLayoutSignals() {
      return this.children.reduce(function (signals, child) {
        return signals.concat(child.assembleLayoutSignals());
      }, _assembleLayoutSignals(this));
    }
  }, {
    key: "assembleSelectionData",
    value: function assembleSelectionData(data) {
      return this.children.reduce(function (db, child) {
        return child.assembleSelectionData(db);
      }, data);
    }
  }, {
    key: "assembleGroupStyle",
    value: function assembleGroupStyle() {
      var uniqueStyles = new Set();
      var _iterator5 = _createForOfIteratorHelper(this.children),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var child = _step5.value;
          var _iterator6 = _createForOfIteratorHelper(array(child.assembleGroupStyle())),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var style = _step6.value;
              uniqueStyles.add(style);
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      var styles = Array.from(uniqueStyles);
      return styles.length > 1 ? styles : styles.length === 1 ? styles[0] : undefined;
    }
  }, {
    key: "assembleTitle",
    value: function assembleTitle() {
      var title = _superPropGet(LayerModel, "assembleTitle", this, 3)([]);
      if (title) {
        return title;
      }
      // If title does not provide layer, look into children
      var _iterator7 = _createForOfIteratorHelper(this.children),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var child = _step7.value;
          title = child.assembleTitle();
          if (title) {
            return title;
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      return undefined;
    }
  }, {
    key: "assembleLayout",
    value: function assembleLayout() {
      return null;
    }
  }, {
    key: "assembleMarks",
    value: function assembleMarks() {
      return assembleLayerSelectionMarks(this, this.children.flatMap(function (child) {
        return child.assembleMarks();
      }));
    }
  }, {
    key: "assembleLegends",
    value: function assembleLegends() {
      return this.children.reduce(function (legends, child) {
        return legends.concat(child.assembleLegends());
      }, _assembleLegends(this));
    }
  }]);
}(Model);